import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faVideoSlash } from "@fortawesome/free-solid-svg-icons";

/**
 * Component for the sidebar containing local preview, live score, and analysis results.
 */
export const VideoSidebar = ({
  localRef,
  isAdminOrCM,
  responses,
  isVideoOn,
  permission,
}) => {
  const showPlaceholder = !isVideoOn || permission !== "granted";

  return (
    <div className="w-full lg:w-[300px] flex flex-col gap-6">
      {/* Local Face View (Mini Video) */}
      <div className="w-full aspect-video bg-black border-2 border-black rounded-xl overflow-hidden shadow-sm relative">
        <video
          ref={localRef}
          autoPlay
          playsInline
          muted
          className={`w-full h-full object-cover ${!showPlaceholder ? "block" : "hidden"}`}
        />
        {showPlaceholder && (
          <div className="w-full h-full flex flex-col items-center justify-center bg-gradient-to-br from-gray-800 to-black">
            <FontAwesomeIcon
              icon={faVideoSlash}
              className="text-white mb-2"
              style={{ fontSize: "2rem" }}
            />
            <span className="text-white text-xs font-medium">
              {permission === "denied"
                ? "Permission Denied"
                : permission === "granted"
                  ? "Camera is off"
                  : "Initializing..."}
            </span>
          </div>
        )}
      </div>

      {/* Live Score/Status Box */}
      {isAdminOrCM && (
        <div className="flex-1 bg-white border rounded-lg border-gray-300 flex flex-col shadow-sm p-3 min-h-[150px] max-h-[300px]">
          <div className="font-bold text-base mb-2 border-b border-gray-100 pb-1 flex justify-between items-center text-gray-800">
            <span>Live Analysis</span>
          </div>
          <div className="flex-1 overflow-y-auto pr-1 custom-scrollbar">
            {responses.length === 0 ? (
              <div className="h-full flex items-center justify-center text-gray-400 italic text-xs">
                No score found
              </div>
            ) : (
              <div className="flex flex-col gap-1">
                {responses.map((res, idx) => {
                  let displayValue = res;
                  let colorClass = "text-gray-600";
                  const isNumber = typeof res === "number";

                  if (isNumber) {
                    displayValue = res.toFixed(6);
                    if (res > 0.23) {
                      colorClass = "text-green-600";
                    } else {
                      colorClass = "text-red-600";
                    }
                  }

                  return (
                    <div
                      key={idx}
                      className="flex items-center border-b border-gray-50 py-0.5 last:border-0"
                    >
                      <span className="font-semibold text-gray-500 text-sm">
                        {/* {isNumber ? "Score:" : "Status:"} */}
                      </span>
                      <span className={`font-bold text-sm ${colorClass}`}>
                        {displayValue}
                      </span>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </div>
      )}

      {/* Analysis Results Display removed as per user instruction to replace Live Score directly and not create other div */}
    </div>
  );
};
